import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { AuthService } from './auth.service';
import { catchError, delay, filter, retryWhen, switchMap, take, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ConfigsLoaderService } from './config-loader.service';
import { MVLocalStorageService } from './mv-local-storage.service';
import { UserModel } from 'app/models/user.model';
import { Tenant } from 'app/models/tenant.model';

@Injectable({
  providedIn: 'root',
})
export class TenantSelectorService {
  private apiEndPoint: string;

  setTenants(tenants: Tenant[]) {
    this._tenants.next(tenants);
  }

  get tenants(): Observable<Tenant[]> {
    return this._tenants.asObservable();
  }

  get selectedTenant(): Observable<Tenant> {
    return this._selectedTenant.asObservable();
  }

  // tslint:disable-next-line: variable-name
  private _tenants = new BehaviorSubject<Tenant[]>([]);
  // tslint:disable-next-line: variable-name
  private _selectedTenant = new BehaviorSubject<Tenant>(undefined);

  constructor(
    private auth: AuthService,
    private http: HttpClient,
    private config: ConfigsLoaderService,
  ) {
    this.apiEndPoint = this.config.apiUrl;

    auth.currentUser$
      .pipe(
        filter(user => !!user)
      )
      .subscribe(user => {
        this._tenants.next(user.managedTenants);
        this.getLocalStorageTenant(user);
      });
  }


  selectTenant(tenant: { id: string, description: string }): void {
    if (tenant) {
      this._selectedTenant.next(tenant);
    } else {
      this._selectedTenant.next(this._tenants.value[0]);
    }
    this.setLocalStorageTenant(tenant);
    if(MVLocalStorageService.getItem('languages')){
      const languages: any[] = JSON.parse(MVLocalStorageService.getItem('languages'))
      languages.forEach(element => {
        if(MVLocalStorageService.getItem(element.id + '.json')){
          MVLocalStorageService.removeItem(element.id + '.json')
        }
      });
      MVLocalStorageService.removeItem('languages')
      MVLocalStorageService.removeItem('selected_lang')
    }
    document.location.reload()
  }

  private getLocalStorageTenant(user?: UserModel) {
    const tenant: Tenant = JSON.parse(MVLocalStorageService.getItem('selected_tenant'));
    if (tenant && this._tenants.value.find(c => c.id === tenant.id)) {
      this._selectedTenant.next(this._tenants.value?.find(c => c.id === tenant.id));
    } else if (this._tenants.getValue().length) {
      const tenantToSelect = this._tenants.value.find(t => t.id == user.tenantId);
      this._selectedTenant.next(tenantToSelect);
      this.setLocalStorageTenant(tenantToSelect);
    } else {
      this.setLocalStorageTenant({id: user.tenantId, description: user.tenantId});
    }
  }

  private setLocalStorageTenant(tenant: Tenant) {
    MVLocalStorageService.setItem('selected_tenant', JSON.stringify(tenant));
    // this.auth.changeDefaultTenant(tenant.id);
  
    // let currentUser = JSON.parse(MVLocalStorageService.getItem('current_user'));
    // currentUser.selectedTenant = tenant.id;
    // MVLocalStorageService.setItem('current_user', JSON.stringify(currentUser));
  }

  currentSelectedTenant(): Tenant {
    return this._selectedTenant.getValue();
  }
}
